import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useThunk } from "../../../hooks/useThunk";
import { clearCreateOrderDraft, fetchUserOrderById } from "../../../store";
import { useDispatch } from "react-redux";
import showToast from "../../../utils/toastNotifications";
import { currencyFormatter } from "../../../utils/formatting";
import { formatYYYY_MM_DD } from "../../../utils/dateFormating";
import { ClipLoader } from "react-spinners";
import ProgressBar from "../../../components/Form/ProgressBar";
import successTick from "../../../assets/Icons/tick.svg";
import { refreshInProgressOrderCount } from "../../../components/Header/useInProgressOrderCount";

const SuccessPayment = () => {
  const navigate = useNavigate();
  const params = useParams();
  const dispatch = useDispatch();
  const [currentOrder, setCurrentOrder] = useState(null);
  const [doFetchUserOrderById, isFetchUserOrderById] = useThunk(fetchUserOrderById);

  const steps = [
    { fullLabel: "Calculation", shortLabel: "Calculation" },
    { fullLabel: "Paper Instructions", shortLabel: "Instructions" },
    { fullLabel: "Additional Services", shortLabel: "Services" },
    { fullLabel: "Secure Payment", shortLabel: "Payment" },
  ];

  useEffect(() => {
    if (!params["*"] || params["*"]?.toString()?.length < 1) {
      navigate("/calculation");
    } else {
      fetchOrdersByIdMethod();
    }
  }, []);

  const handleProceed = () => {
    dispatch(clearCreateOrderDraft());
    navigate(
      `/thread?roomIdParam=${currentOrder?.id}&threadIdParam=${currentOrder?.threadId}`,
      {
        state: { backRedirect: "/dashboard" },
        replace: true 
      }
    );
  };

  const fetchOrdersByIdMethod = async () => {
    const result = await doFetchUserOrderById({ id: params["*"] });
    if (result?.success) {
      refreshInProgressOrderCount();
      setCurrentOrder(result?.response?.data);
      showToast("success", "Order placed successfully");
    } else {
      showToast("error", result?.error?.message);
    }
  };

  return (
    <div className="min-h-screen w-full flex flex-col">
      {/* Top bar/dashboard */}
      <div className="flex items-center justify-between py-6 px-10">
        <h2 className="text-[#1b2e77] text-[24px] font-bold cursor-pointer" onClick={() => navigate("/dashboard")}>Dashboard</h2>
        {/* TODO: Insert user info and notification here */}
      </div>

      {/* Main Card Centered */}
      <div className="flex-grow flex items-center justify-center px-4 md:px-0">
        <div className="w-full max-w-[850px] bg-white rounded-2xl p-2 sm:p-12 shadow-none">
          <ProgressBar steps={steps} activeStep={4} completedStep={4} />
          {isFetchUserOrderById ? (
            <div className="flex justify-center mt-24">
              <ClipLoader size={82} color="#1b2e77" speedMultiplier={0.5} />
            </div>
          ) : (
            <>
              <h2 className="text-center font-semibold text-[#2c365e] text-[30px] mt-10  mb-3">
                Payment Success !
              </h2>

              {/* Tick with concentric circles */}
              <div className="w-full rounded-full flex items-center justify-center mb-3">
                <img
                  src={successTick}
                  alt="Success Icon"
                  className="w-[120px] h-[120px] sm:w-[200px] sm:h-[200px]"
                />
              </div>
              

              {/* Info table with separated rows */}
              <div className="w-full max-w-[616px] mx-auto p-1 sm:p-6">
                {[{
                  label: "Payment Receipt ID",
                  value: currentOrder?.paymentDetils?.paypalPaymentId || "ABC01245634",
                },{
                  label: "Payment Method",
                  value: currentOrder?.paymentDetils?.method || "PayPal",
                  capitalize: true,
                },{
                  label: "Payment Date",
                  value: formatYYYY_MM_DD(currentOrder?.paymentDetils?.createdAt) || "2024-10-24",
                },{
                  label: "Total Payment",
                  value: currencyFormatter.format(currentOrder?.price || 120) || "$120.00",
                  isTotal: true,
                }].map(({ label, value, capitalize, isTotal }, idx, arr) => (
                  <div
                    key={label}
                    className={`flex justify-between items-center px-5 py-4 rounded  ${
                      idx !== arr.length - 1 ? "mb-6" : ""
                    }`}
                    style={{ boxShadow: '1px 2px 8px 1px #0020BD1F' }}
                  >
                    <span
                      className={`text-left text-sm font-medium ${
                        isTotal ? "text-[#0020BD]" : "text-[#2F3464]"
                      }`}
                    >
                      {isTotal ? <strong>{label}</strong> : label}
                    </span>
                    <span
                      className={`text-right text-sm font-medium ${
                        isTotal ? "text-[#0020BD] " : "text-[#2F3464]"
                      } ${capitalize ? "capitalize" : ""}`}
                    >
                      {value}
                    </span>
                  </div>
                ))}
              </div>

              {/* Buttons */}
              <div className="flex justify-between max-w-[616px] mx-auto mt-12 p-1 sm:p-6">
                <button
                  type="button"
                  // onClick={() => navigate(`/secure-payment/${currentOrder?._id}`)}
                  onClick={() => navigate(`/`)}
                  className="bg-[#0020BD] text-white py-2 px-8 rounded-[5px] text-base font-semibold flex items-center gap-2 hover:bg-[#001a95] transition"
                >
                  <span className="text-lg">&#8592;</span> Back
                </button>
                <button
                  type="button"
                  onClick={handleProceed}
                  className="bg-[#0020BD] text-white py-2 px-8 rounded-[5px] text-base font-semibold flex items-center gap-2 hover:bg-[#001a95] transition"
                >
                  Continue <span className="text-lg">&#8594;</span>
                </button>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default SuccessPayment;
